import { axios } from '@Root/API'

export const changeFormStatus = (applicationId, applicationStatusId) => {
	return axios.post('change/applications/status', {
		application_id: applicationId,
		application_status_id: applicationStatusId,
	})
}
